import { useStore } from "@nanostores/preact";
import { useState } from "preact/hooks";
import { ApiError, transferAsset } from "../net/api";
import { dropFromHotbar } from "../state/hotbar";
import { $panel, $transferCode, toast } from "../state/stores";
import { describeError } from "./errors";
import { Panel } from "./Panel";
import { refreshMyAssets } from "../state/myAssets";

export function TransferPanel() {
  const code = useStore($transferCode);
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!code) return null;

  async function submit(e: Event) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await transferAsset(code!, to.trim());
      dropFromHotbar(code!);
      await refreshMyAssets();
      toast("轉讓完成");
      $panel.set("inventory");
    } catch (err) {
      setError(err instanceof ApiError ? describeError(err.code) : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Panel title={`轉讓 ${code}`} onClose={() => $panel.set("inventory")}>
      <form onSubmit={submit}>
        <label>收件者 email 或帳號 id</label>
        <input type="text" required value={to} onInput={(e) => setTo((e.target as HTMLInputElement).value)} />
        <p class="hint">轉讓會寫入帳本且無法撤銷。</p>
        <button type="submit" disabled={busy}>確認轉讓</button>
        {error && <div class="error">{error}</div>}
      </form>
    </Panel>
  );
}
